<template lang="pug">
  app-page(title="Управление судами" :fabItems="fabItems" )
    app-toolbar(:title="'Список судов'")

    app-empty-list(v-if="courts.length == 0") Список пуст
    app-group-animation
      app-group-item(v-for="c in courts" :key="c.id" cols="4")
        app-card(@click.native="moveCourt(c)")
          app-card-header 
            app-card-title {{ c.name }}
          app-card-body
            app-card-caption 
              card-row-label-value(label="Алиас суда" :value="c.alias")
              card-row-label-value(label="Адрес"      :value=" c.address")
              card-row-label-value(label="Телефон"    :value="c.phone")
              card-row-label-value(label="Факс"       :value="c.fax")
              card-row-label-value(label="E-mail"     :value="c.email")
              card-row-label-value(label="Сайт"       :value="c.site")

    app-dialog(v-model="dialog.court" @confirm="saveCourt()" confirmText="Отправить" header="Карточка суда" width="800")
      v-layout
        v-flex(xs6)
          app-card-title Карточка суда
          app-text-field(v-model="court.name"  label="Наименование суда")
          app-text-field(v-model="court.city"  label="Город")
          app-text-field(v-model="court.alias" label="Алиас" :disabled="!newCourt")
          app-text-field(v-model="court.gasId" label="GAS ID" )
        v-flex.ml-8(xs6)
          app-card-title Карточка otpravka.pochta.ru
          app-text-field(v-model="court.postToken"    label="Токен авторизации")
          app-text-field(v-model="court.postLogin"    label="Login")
          app-text-field(v-model="court.postPassword" label="Password")
          
      v-layout    
        v-flex(xs12)
          app-card-title Контакты
      v-layout  
        v-flex(xs12)
          app-text-field(v-model="court.address" label="Адрес")
      v-layout  
        v-flex(xs6)
          app-text-field(v-model="court.phone"   label="Телефон")
          app-text-field(v-model="court.fax"     label="Факс")
        v-flex.ml-8(xs6)
          app-text-field(v-model="court.email"   label="E-mail")
          app-text-field(v-model="court.site"    label="Сайт")
      
      v-layout.mb-3(v-if="!newCourt")
        v-flex(xs6)
          app-card-title Добавить штамп
          v-btn.mx-0(@click="$refs.localfile.click()") Выберите файл
            v-icon(right dark) attach_file
          input(id="sud-upload-stamp-id" type="file" style="display: none" ref="localfile" @change="changeFile")
        v-flex.ml-10(xs6)
          div(v-if="stamp")
            img(:src="'data:image/jpg;base64,' + stamp" width="200px")     

      v-snackbar(v-model="errorSnack" color="error" :timeout="6000" vertical top) {{errorSnackText}}
        v-btn(light text @click="errorSnack = false") Закрыть
      v-snackbar(v-model="successSnack" color="success" :timeout="6000" vertical top) {{successSnackText}}
        v-btn(light text @click="successSnack = false") Закрыть

      v-layout(v-if="!newCourt")    
        v-flex(xs12)
          app-card-title Управление конфигурацией (распределения, почтовый сервис) 
          app-button(color="#959595" @click.native="showConfig()") Конфигурация

          app-button.ml-4(color="#959595" @click.native="testSMTP()") SMTP Tест

          app-button.ml-4(color="#959595" @click.native="resetSMTP()") SMTP/IMAP Reset


          
    app-dialog(v-model="dialog.courtConfig" @confirm="saveCourtConfig()" confirmText="Отправить" header="Конфигурация суда" width="750" )
      app-text-field(
        v-model="courtConfig.distribMaterial" 
        label="Материалы участвующие в распределение за период, дней(0 - без материалов, '-1' - за весь период)"
        append-outer-icon="add" 
        prepend-outer-icon="remove" 
        @click:prepend-outer="courtConfig.distribMaterial -= 1" 
        @click:append-outer="courtConfig.distribMaterial += 1"
      )
      app-text-field(
        v-model="courtConfig.distribWeightFull" 
        label="Вес влияние общего кол-ва дел на распределение (0 - не влияет, чем больше значение, тем больше влиянее)"
        append-outer-icon="add" 
        prepend-outer-icon="remove" 
        @click:prepend-outer="courtConfig.distribWeightFull -= 1" 
        @click:append-outer="courtConfig.distribWeightFull += 1"
      )
      v-switch(v-model="courtConfig.distribCivilGroup" label="Гр. распределять с учетом групп категорий дел")
      v-switch(v-model="courtConfig.distribCriminalGroup" label="Уг. распределять с учетом групп категорий дел")
      v-switch(v-model="courtConfig.distribReturn" label="Распределять возвращенные дела")
      v-switch(v-model="courtConfig.postEnabled" label="Отправка писем и реестров на почтовый сервис")

      app-text-field(v-model="courtConfig.vipnetMark"   label="VIPNET признак")
      app-text-field(v-model="courtConfig.vipnetReceiveAdapter"   label="VIPNET GATEWAY URL")

      h2.my-4 SMTP

      app-text-field(v-model="courtConfig.smtpHost" label="SMTP Host")
      app-text-field(v-model="courtConfig.smtpPort" label="SMTP Port")
      app-text-field(v-model="courtConfig.smtpUsername" label="SMTP Username")
      app-text-field(v-model="courtConfig.smtpPassword" label="SMTP Password")
      app-text-field(v-model="courtConfig.smtpFrom" label="SMTP From")

      h2.my-4 IMAP

      v-switch(mt-4 v-model="courtConfig.imapOn" label="Включить IMAP")
      v-switch(v-model="courtConfig.imapSsl" label="IMAP SSL")
      app-text-field(v-model="courtConfig.imapHost" label="IMAP Host")
      app-text-field(v-model="courtConfig.imapPort" label="IMAP Port")
      app-text-field(v-model="courtConfig.imapUser" label="IMAP Username")
      app-text-field(v-model="courtConfig.imapPassword" label="IMAP Password")
      app-text-field(v-model="courtConfig.imapFolder" label="IMAP Folder")



</template>

<script>
import { courtService, docService } from '@/_services'
import CardRowLabelValue from './components/CardRowLabelValue'
import Meeting from '@/common/Meeting'

export default {
  mixins: [ Meeting ],

  components: {
    CardRowLabelValue
  },
  data() {
    const defaultForm = Object.freeze({
        name:	null,
        city:	null,
        alias:	null,
        address: null,
        phone: null,
        fax: null,
        email: null,
        site: null,
        postToken: null,
        postLogin: null,
        postPassword: null,
    })
    return {
      errorSnackText: "",
      successSnackText: "",
      errorSnack: false,
      successSnack: false,
      courts: [],
      court: Object.assign({}, defaultForm),
      defaultForm,
      courtConfig: '',
      stamp: '',
      dialog: {
        court: false,
        courtConfig: false
      },
      newCourt: false
    }
  },

  mounted () {
    this.loadCourts()
  },

  computed: {
    fabItems () {
      return this.$_meeting_isAvailable ? [{ icon:'add', title:'Добавить суд', action: () =>  this.createCourt()}] : []
    },
  },

  methods: {
    showErrorSnack(text) {
      this.errorSnackText = text
      this.errorSnack = true
    },

    showSuccessSnack(text) {
      this.successSnackText = text
      this.successSnack = true
    },

    testSMTP () {
      courtService.testSmtp().then(data => {
        if(data.status=="OK")  this.showSuccessSnack("SMTP проверка успешна");
        else this.showErrorSnack("Ошибка SMTP: " + data.error);
      })
    },

    resetSMTP () {
      courtService.resetSmtp().then(data => {
        if(data.status=="OK")  this.showSuccessSnack("Настройки SMTP/IMAP обновлены");
        else this.showErrorSnack("Ошибка: " + data.error);
      })
    },



    loadCourts () {
      courtService.getCourt().then(data => {
        this.courts = data
      })
    },

    moveCourt (court) {
      this.court = court
      this.dialog.court = true
      this.getStamp()
    },

    saveCourt() {
      this.court.stampImage = ""
      courtService.saveCourt(this.court).then(() => this.loadCourts())
    },

    showConfig () {
      courtService.getCourtConfig(this.court).then(data => {
        this.courtConfig = data
        this.dialog.courtConfig = true
      })
    },

    saveCourtConfig() {
      courtService.saveCourtConfig(this.courtConfig).then(data => this.courtConfig = data)
    },

    changeFile () {
      let input = document.getElementById('sud-upload-stamp-id')
      this.court.stampImage = input.files[0].name
      this.uploadFile()
    },

    uploadFile () {
      var formData = new FormData();
      var imagefile = document.getElementById('sud-upload-stamp-id')
      formData.append("file", imagefile.files[0])

      docService.uploadRfiles(formData)
      .then(data => {
        this.court.stampImage = data
        courtService.saveCourt(this.court).then(() => this.getStamp())
      })
    },

    getStamp () {
      courtService.getStamp(this.court).then(data => this.stamp = data )
    },

    createCourt() {
      this.newCourt = true
      this.court = JSON.parse(JSON.stringify(this.defaultForm))
      this.dialog.court = true
    }
  },
}
</script>